<template>
  <div v-if="masterCampaign">
    <vx-card>
      <vs-row vs-justify="space-between">
        <vs-col vs-w="6">
          <h3 class="mr-4">Campaign approval process</h3>
          <p class="mt-5">
            The campaign has been assigned to the following venues. <br />
            Here you can review them and decide to approve or reject.
          </p>
        </vs-col>
      </vs-row>

      <vs-row class="mt-2">
        <vs-button @click="onRefresh">Refresh list</vs-button>
      </vs-row>

      <!-- table -->
      <div class="data-list-container data-list-list-view">
        <!-- <h3>{{ activeVenue.name }}</h3> -->
        <vs-table
          ref="table"
          class="mt-8"
          maxItems="10"
          v-model="selected"
          pagination
          search
          :data="venueCampaigns"
          @selected="onClicked(selected.id)"
        >
          <div
            slot="header"
            class="
              flex flex-wrap-reverse
              items-center
              flex-grow
              justify-between
            "
          >
            <div
              class="
                flex flex-wrap-reverse
                items-center
                data-list-btn-container
              "
            >
              <!-- ADD NEW -->
            </div>

            <!-- ITEMS PER PAGE -->
          </div>
          <template slot="thead">
            <vs-th sort-key="venueName">Venue name</vs-th>
            <vs-th sort-key="status">Status</vs-th>
            <vs-th sort-key="approvedByDate">VM fill out by</vs-th>
            <vs-th sort-key="sendEmailDate" v-if="masterCampaign.hasEmail"
              >Send Email date</vs-th
            >
            <vs-th sort-key="sendSmsDate" v-if="masterCampaign.hasSms"
              >Send Sms date</vs-th
            >
            <vs-th sort-key="sendNpPushDate" v-if="masterCampaign.hasNpPush"
              >Send Np Push date</vs-th
            >
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                <vs-td>
                  <p class="product-name font-medium truncate">
                    {{ tr.venueName }}
                  </p>
                </vs-td>
                <vs-td :key="tr.status">
                  <vs-chip
                    :color="statusObject(tr.status).color"
                    class="product-order-status"
                  >
                    {{ statusObject(tr.status).text }}
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    {{ tr.approvedByDate | date(true) }}
                  </p>
                </vs-td>
                <vs-td v-if="masterCampaign.hasEmail">
                  <vs-row @click.native.stop.prevent>
                    <div
                      v-if="
                        isEditingDate &&
                        tr.id === editingDateCampaign.id &&
                        editingDateType == 'sendEmailDate'
                      "
                    >
                      <flat-pickr
                        :config="datePickerConfig"
                        v-model="editingDate"
                        placeholder="Email send date"
                        class="p-3 s-inputx vs-input--input flex"
                      />
                    </div>
                    <div v-else>
                      <vs-chip
                        color="danger"
                        v-if="
                          isDateLateForActiveMaster(tr.sendEmailDate) &&
                          !tr.hasSentEmail
                        "
                      >
                        {{ tr.sendEmailDate | formatDate }}
                      </vs-chip>
                      <p v-else>
                        {{ tr.sendEmailDate | formatDate }}
                      </p>
                    </div>
                    <div
                      v-if="
                        isEditingDate &&
                        tr.id === editingDateCampaign.id &&
                        editingDateType == 'sendEmailDate'
                      "
                      class="flex items-center"
                    >
                      <feather-icon
                        class="cursor-pointer ml-4"
                        icon="CheckIcon"
                        svgClasses="w-5 h-5"
                        @click="saveDate()"
                      />
                      <feather-icon
                        class="cursor-pointer ml-4"
                        :icon="'XIcon'"
                        svgClasses="w-5 h-5"
                        @click="cancelDateEdit()"
                      />
                    </div>
                    <feather-icon
                      v-else-if="
                        masterCampaign.masterStatus == 'Active' &&
                        !tr.hasSentEmail
                      "
                      class="cursor-pointer ml-4"
                      icon="EditIcon"
                      svgClasses="w-5 h-5"
                      @click="editDate(tr, 'sendEmailDate')"
                    />
                  </vs-row>
                </vs-td>
                <vs-td v-if="masterCampaign.hasSms">
                  <vs-row @click.native.stop.prevent>
                    <div
                      v-if="
                        isEditingDate &&
                        tr.id === editingDateCampaign.id &&
                        editingDateType == 'sendSmsDate'
                      "
                    >
                      <flat-pickr
                        :config="datePickerConfig"
                        v-model="editingDate"
                        placeholder="SMS send date"
                        class="p-3 s-inputx vs-input--input flex"
                      />
                    </div>
                    <div v-else>
                      <vs-chip
                        color="danger"
                        v-if="
                          isDateLateForActiveMaster(tr.sendSmsDate) &&
                          !tr.hasSentSms
                        "
                      >
                        {{ tr.sendSmsDate | formatDate }}
                      </vs-chip>
                      <p v-else>
                        {{ tr.sendSmsDate | formatDate }}
                      </p>
                    </div>
                    <div
                      v-if="
                        isEditingDate &&
                        tr.id === editingDateCampaign.id &&
                        editingDateType == 'sendSmsDate'
                      "
                      class="flex items-center"
                    >
                      <feather-icon
                        class="cursor-pointer ml-4"
                        icon="CheckIcon"
                        svgClasses="w-5 h-5"
                        @click="saveDate()"
                      />
                      <feather-icon
                        class="cursor-pointer ml-4"
                        :icon="'XIcon'"
                        svgClasses="w-5 h-5"
                        @click="cancelDateEdit()"
                      />
                    </div>
                    <feather-icon
                      v-else-if="
                        masterCampaign.masterStatus == 'Active' &&
                        !tr.hasSentSms
                      "
                      class="cursor-pointer ml-4"
                      icon="EditIcon"
                      svgClasses="w-5 h-5"
                      @click="editDate(tr, 'sendSmsDate')"
                    />
                  </vs-row>
                </vs-td>
                <vs-td v-if="masterCampaign.hasNpPush">
                  <vs-row @click.native.stop.prevent>
                    <div
                      v-if="
                        isEditingDate &&
                        tr.id === editingDateCampaign.id &&
                        editingDateType == 'sendNpPushDate'
                      "
                    >
                      <flat-pickr
                        :config="datePickerConfig"
                        v-model="editingDate"
                        placeholder="NightPay push send date"
                        class="p-3 s-inputx vs-input--input flex"
                      />
                    </div>
                    <div v-else>
                      <vs-chip
                        color="danger"
                        v-if="
                          isDateLateForActiveMaster(tr.sendNpPushDate) &&
                          !tr.hasSentNpPush
                        "
                      >
                        {{ tr.sendNpPushDate | formatDate }}
                      </vs-chip>
                      <p v-else>
                        {{ tr.sendNpPushDate | formatDate }}
                      </p>
                    </div>
                    <div
                      v-if="
                        isEditingDate &&
                        tr.id === editingDateCampaign.id &&
                        editingDateType == 'sendNpPushDate'
                      "
                      class="flex items-center"
                    >
                      <feather-icon
                        class="cursor-pointer ml-4"
                        icon="CheckIcon"
                        svgClasses="w-5 h-5"
                        @click="saveDate()"
                      />
                      <feather-icon
                        class="cursor-pointer ml-4"
                        :icon="'XIcon'"
                        svgClasses="w-5 h-5"
                        @click="cancelDateEdit()"
                      />
                    </div>
                    <feather-icon
                      v-else-if="
                        masterCampaign.masterStatus == 'Active' &&
                        !tr.hasSentNpPush
                      "
                      class="cursor-pointer ml-4"
                      icon="EditIcon"
                      svgClasses="w-5 h-5"
                      @click="editDate(tr, 'sendNpPushDate')"
                    />
                  </vs-row>
                </vs-td>

                <vs-td class="whitespace-no-wrap">
                  <feather-icon
                    icon="TrashIcon"
                    v-if="
                      hasPermission('vp.crm.campaigns.edit') &&
                      tr.status != 'Archived' &&
                      tr.status != 'Cancelled'
                    "
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="confirmDelete(tr)"
                  />
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <preview-popup ref="previewPopup" v-on:onSubmit="onRefresh" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import campaignMixin from "@/views/mixins/campaignMixin";
import PreviewPopup from "./PreviewCampaignPopup.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: { PreviewPopup, flatPickr },
  mixins: [campaignMixin],
  props: ["masterCampaign"],
  data() {
    return {
      moment,
      selected: [],

      isEditingDate: false,
      editingDateCampaign: null,
      editingDateType: null,
      editingDate: null,

      datePickerConfig: {
        enableTime: true, // Set to true for time again
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "Z",
        altFormat: "Y-m-d H:i", // "d-m-Y H:i" for time 2021-11-19T19:00:00Z
        altInput: true,
      },
    };
  },
  methods: {
    editDate(campaign, type) {
      console.log("EDIT DATE", campaign, type);
      this.isEditingDate = true;
      this.editingDateCampaign = campaign;
      this.editingDateType = type;
      this.editingDate = campaign[type];
    },
    cancelDateEdit() {
      this.isEditingDate = false;
      this.editingDateCampaign = null;
      this.editingDateType = null;
      this.editingDate = null;
    },
    async saveDate() {
      try {
        this.$vs.loading({ text: "Changing date..." });

        await this.$store.dispatch("venueCampaigns/changeMediaDateTo", {
          venueCampaignId: this.editingDateCampaign.id,
          mediaType: this.editingDateType,
          date: this.editingDate,
        });
        this.$vs.notify({
          color: "green",
          title: "Date changed",
          text: "The date of the campaign was successfully changed",
        });

        // Change date visually
        this.editingDateCampaign[this.editingDateType] = this.editingDate;
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Cannot change date",
          text: err,
          time: 4000,
        });
      } finally {
        this.isEditingDate = false;
        this.editingDateCampaign = null;
        this.editingDateType = null;
        this.editingDate = null;
        this.$vs.loading.close();
      }
    },
    async onClicked(id) {
      await this.$store.dispatch("venueCampaigns/get", id);
      this.$refs.previewPopup.show(
        this.venueCampaign,
        this.masterCampaign,
        true
      );
    },
    async onRefresh() {
      await this.$store.dispatch(
        "venueCampaigns/getForMasterCampaign",
        this.masterCampaign.id
      );
    },
    isDateLateForActiveMaster(date) {
      return (
        this.masterCampaign.masterStatus == "Active" &&
        moment(date).isBefore(moment())
      );
    },

    confirmDelete(campaign) {
      const cancelText =
        campaign.status == "ReadyToFillOut" ? "Archive" : "Cancel";

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Are you sure you want to ${cancelText} the campaign for venue ${campaign.venueName}?`,
        accept: async () => {
          try {
            await this.$store.dispatch("venueCampaigns/delete", {
              venueCampaignId: campaign.id,
              byHQ: true,
            });
            this.$vs.notify({
              color: "green",
              title: "Success",
              text: `${cancelText} campaign was successful`,
            });
          } catch (err) {
            console.error(err);

            this.$vs.notify({
              color: "danger",
              title: `Could not ${cancelText} the campaign`,
              text: err,
              time: 4000,
            });
          }
        },
      });
    },
  },
  computed: {
    ...mapGetters({
      venueCampaigns: "venueCampaigns/masterVenueCampaigns",
      venueCampaign: "venueCampaigns/venueCampaign",
    }),
  },

  async created() {
    console.log("Getting for id", this.masterCampaign.id);
    await this.$store.dispatch(
      "venueCampaigns/getForMasterCampaign",
      this.masterCampaign.id
    );
  },
};
</script>

<style lang="scss">
</style>
